/**
 * Loads survey-backed financial fields used on the Invoice page workspace.
 */

/** Sum breakdown amounts for Others (survey / invoice invoice_meta.extra_lines). */
export function sumOthersLineAmounts(rows, { onlySelected = false } = {}) {
  if (!rows || !rows.length) return 0
  return rows.reduce((acc, row) => {
    if (onlySelected && row?.selected === false) return acc
    const n = parseFloat(String(row?.amount ?? '').replace(/,/g, ''))
    return acc + (Number.isFinite(n) ? n : 0)
  }, 0)
}

export function surveyToFinancialDraft(survey) {
  if (!survey) return null
  const s = (v, def) => (v != null && v !== '' ? String(v) : def)

  return {
    lsfo_logbook: s(survey.lsfo_logbook, '0.000'),
    lsfo_survey: s(survey.lsfo_survey, '0.000'),
    lsfo_qty: s(survey.lsfo_qty, '0.000'),
    lsfo_bdn: s(survey.lsfo_bdn, '0.000'),
    lsfo_vessel: s(survey.lsfo_vessel, '0.000'),
    lsfo_barge_name: survey.lsfo_barge_name || '',
    lsfo_price: s(survey.lsfo_price, '0.00'),
    lsfo_recovery: s(survey.lsfo_recovery, '0.00'),
    hsfo_logbook: s(survey.hsfo_logbook, '0.000'),
    hsfo_survey: s(survey.hsfo_survey, '0.000'),
    hsfo_qty: s(survey.hsfo_qty, '0.000'),
    hsfo_bdn: s(survey.hsfo_bdn, '0.000'),
    hsfo_vessel: s(survey.hsfo_vessel, '0.000'),
    hsfo_barge_name: survey.hsfo_barge_name || '',
    hsfo_price: s(survey.hsfo_price, '0.00'),
    hsfo_recovery: s(survey.hsfo_recovery, '0.00'),
    mgo_logbook: s(survey.mgo_logbook, '0.000'),
    mgo_survey: s(survey.mgo_survey, '0.000'),
    mgo_qty: s(survey.mgo_qty, '0.000'),
    mgo_bdn: s(survey.mgo_bdn, '0.000'),
    mgo_vessel: s(survey.mgo_vessel, '0.000'),
    mgo_barge_name: survey.mgo_barge_name || '',
    mgo_price: s(survey.mgo_price, '0.00'),
    mgo_recovery: s(survey.mgo_recovery, '0.00'),
    pct_qty: survey.pct_qty != null && survey.pct_qty !== '' ? String(survey.pct_qty) : '',
    mt_price: survey.mt_price != null && survey.mt_price !== '' ? String(survey.mt_price) : '',
    recovery: survey.recovery != null && survey.recovery !== '' ? String(survey.recovery) : '',
    survey_fee: survey.survey_fee != null && survey.survey_fee !== '' ? String(survey.survey_fee) : '',
    expenses: survey.expenses != null && survey.expenses !== '' ? String(survey.expenses) : '',
    discount: survey.discount != null && survey.discount !== '' ? String(survey.discount) : '',
    others: survey.others != null && survey.others !== '' ? String(survey.others) : '',
    total: survey.total != null && survey.total !== '' ? String(survey.total) : '',
    subcon: survey.subcon || '',
    subcon_fee_paid: Boolean(survey.subcon_fee_paid),
  }
}

/** Recompute survey-style total when core charge fields change (invoice workspace). */
export function recalcFinancialDraftTotals(d) {
  if (!d || typeof d !== 'object') return d
  const num = (v) => parseFloat(String(v ?? '').replace(/,/g, '')) || 0
  const recovery = num(d.recovery)
  const surveyFee = num(d.survey_fee)
  const expenses = num(d.expenses)
  const others = num(d.others)
  const discount = num(d.discount)
  const totalVal = recovery + surveyFee + expenses + others - discount
  return {
    ...d,
    total: totalVal.toFixed(2),
  }
}

export function initPctMtFlags(survey) {
  if (!survey) {
    return { pctDisabled: false, mtPriceDisabled: false }
  }
  if (survey.mt_price !== null && survey.mt_price !== undefined && survey.mt_price !== '') {
    return { pctDisabled: true, mtPriceDisabled: false }
  }
  if (survey.pct_qty !== null && survey.pct_qty !== undefined && survey.pct_qty !== '') {
    return { pctDisabled: false, mtPriceDisabled: true }
  }
  return { pctDisabled: false, mtPriceDisabled: false }
}
